// src/pages/ServiceDetail.js  ← YENİ
import React from "react";
import SERVICES from "../data/services.json";
import ServiceIcon from "../components/ServiceIcon";

export default function ServiceDetail({ keyParam }) {
  const svc = SERVICES.find((s) => s.key === keyParam);
  if (!svc) {
    return (
      <section className="section"><div className="container">
        <h1 className="page-title">Hizmet Bulunamadı</h1>
        <p className="page-subtitle">Aradığınız hizmet listede yok.</p>
        <a className="btn ghost" href="/services">Hizmetlere Dön</a>
      </div></section>
    );
  }
  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">{svc.title}</h1>
          <p className="page-subtitle">{svc.desc}</p>
        </header>

        <div className="detail-hero">
          <img src={svc.img} alt={`${svc.title} görseli`} loading="eager" decoding="async" />
          <div className="detail-hero-meta">
            <ServiceIcon name={svc.key} className="icon-lg" />
            <p>Bu hizmet için keşif ve fiyatlandırma aynı gün içinde yapılır.</p>
            {/* <a className="btn primary" href="/contact#form">Teklif Al</a> */}
          </div>
        </div>

        <div className="detail-body">
          <h3>Öne Çıkanlar</h3>
          <ul className="bullet">
            <li>Standartlara uygun güvenlik ve çevre önlemleri</li>
            <li>Deneyimli ekip ve hızlı mobilizasyon</li>
            <li>Şeffaf sözleşme ve raporlama</li>
          </ul>
        </div>
      </div>
    </section>
  );
}